<div style="display:flex;flex-direction: row;align-items:center">
    {{ (sessionManager?.status | async )?.description }}

    <button *ngIf="(sessionManager?.status | async)?.canOpen" (click)="sessionManager.openSession()">Open Session</button>
    
</div>
